export default class UserRewardsManagerState {}
